import { Api } from '@automapa/svelte-automapa-template';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
import { z } from 'zod';

// export const RealisationRoutePointSchema = z
//     .object({
//         new: z.any().nullable().catch(null),
//         approached: z.coerce.number().nullable().catch(null),
//         completed: z.coerce.number().nullable().catch(null),
//         route_points: z.array(z.any()).catch([]),
//     })
//     .describe('DEPRECATED ---- https://er.automapa.pl/issues/41165')
//     .catch({ new: null, approached: null, completed: null, route_points: [] });
// export type RealisationRoutePointType = z.infer<typeof RealisationRoutePointSchema>;

/*
{
  "details": {
    "status": "completed",
    "completed": 1720124794,
    "delivered": {
      "2635013": 1720124794
    },
    "approached": 1720124793
  }
}*/

/*
examples:
{"delivered": {"518713": 1744614564}, "approached": 1744609625}
{"status": "current", "approached": 1737749086}
{"new": true}
{"rejected": {"518463": 1744352793}, "delivered": {"518464": 1744352707}, "approached": 1744352692}
{"status": "completed", "completed": 1737729238, "delivered": {"114078": 1737729238}, "approached": 1737729231}
{"status": "completed", "completed": 1738582381, "delivered": {"361541": 1738582296, "396144": 1738582316, "396150": 1738582347, "396210": 1738582381}, "approached": 1738582286}
{"status": "completed", "rejected": {"518554": 1744620066}, "completed": 1744620066, "approached": 1744609678}
 */
export const DetailsRoutePointSchema = z
    .object({
        new: z.boolean().optional().describe('wtf???'),
        status: z.string().default('').describe('completed | current | rejected?'),
        completed: z.coerce.number().nullable().default(null).describe('timestamp'),
        approached: z.coerce.number().nullable().default(null).describe('timestamp'),
        rejected: z
            .record(z.coerce.number())
            .nullable()
            .default(null)
            .describe('job_id::string -> timestamp::number'),
        delivered: z
            .record(z.coerce.number())
            .nullable()
            .default(null)
            .describe('job_id::string -> timestamp::number'),
    })
    .catch({ status: '', completed: null, delivered: null, approached: null, rejected: null });
export type DetailsRoutePointType = z.infer<typeof DetailsRoutePointSchema>;

export const RoutePointSimpleSchema = z.object({
    id: z.number(),
    details: DetailsRoutePointSchema, // z.any(),
});
export type RoutePointSimpleType = z.infer<typeof RoutePointSimpleSchema>;

export const RoutePointDeltaSchema = z.object({
    d: z.number().default(0).describe('distance in meters from previous point'),
    g: z
        .object({
            d: z.number().describe('global distance in meters from first point'),
            m: z
                .number()
                .describe(
                    'to, afair, minuty od północy https://matkomunikator.automapa.pl:801/automapa/pl/eud6nfrfbjdijyt7muixbuzseh'
                ),
            t: z.number().describe('global time in minutes from first point'),
        })
        .default({ d: 0, m: 0, t: 0 }),
    t: z.number().default(0).describe('time in minutes from previous point'),
});
export type RoutePointDeltaType = z.infer<typeof RoutePointDeltaSchema>;

export const RoutePointExtendedSchema = RoutePointSimpleSchema.merge(
    z.object({
        // id: z.number(),
        // details: DetailsRoutePointSchema,
        assignment_id: z.number(),
        address_id: z.number().nullable(),
        point_order: z.number(),
        jobs: z.array(z.number()).nullable().catch(null),
        geom: z.object({
            type: z.literal('Point'),
            coordinates: z.array(z.number()),
        }),
        address_geocoded: z
            .object({
                city: z.string().catch(''),
                house: z.string().catch(''),
                street: z.string().catch(''),
                country: z.string().catch(''),
            })
            .nullable(),
        address_imported: z
            .object({
                city: z.string().catch(''),
                house: z.string().catch(''),
                street: z.string().catch(''),
            })
            .nullable().catch(null),
        job_delay: z.array(z.any()).nullable(),
        delta: RoutePointDeltaSchema.nullable(),
        revision: z.string().catch(''),
        // realisation: RealisationRoutePointSchema,
    })
);
export type RoutePointExtendedType = z.infer<typeof RoutePointExtendedSchema>;

export class RoutePointsApi {
    static async getPoints(api: Api, assignmentId: number): Promise<RoutePointExtendedType[]> {
        let f = new ApiFilterBuilder(-1);
        f.sortBy('point_order', 'asc');
        f.filterByNumber('assignment_id', assignmentId);
        return api.getData<undefined, RoutePointExtendedType[]>(
            'get',
            '/route_points' + f.getUri(),
            undefined,
            z.undefined(),
            z.array(RoutePointExtendedSchema)
        );
    }
}
